import { ReactUnityEventParameter } from 'react-unity-webgl/distribution/types/react-unity-event-parameters';
import React, { useEffect } from 'react';
import { UnityMessageIncomingEvent } from 'app/common/eventbus/Events';

type TProps = {
    addEventListener: (
        eventName: string,
        callback: (...parameters: ReactUnityEventParameter[]) => ReactUnityEventParameter,
    ) => void;
    removeEventListener: (
        eventName: string,
        callback: (...parameters: ReactUnityEventParameter[]) => ReactUnityEventParameter,
    ) => void;
};

export const UnityCanvasEventNotificationForwarder = ({ addEventListener, removeEventListener }: TProps) => {
    useEffect(() => {
        const handleEvent = (serializedData: ReactUnityEventParameter) => {
            if (!serializedData) {
                throw new Error('Notification sent from Unity application unexpectedly has no data');
            }

            UnityMessageIncomingEvent.fire(serializedData?.toString());
        };

        addEventListener('ContentViewerEvent', handleEvent);

        return () => {
            removeEventListener('ContentViewerEvent', handleEvent);
        };
    }, [addEventListener, removeEventListener]);

    return <></>;
};
